import { forwardRef } from "react";

const Page = forwardRef(({ children, className, ...rest }, ref) => {
  return <section {...rest} className={className} ref={ref}>{children}</section>;
});

export default Page;
